import { AlertTriangle, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button.tsx';

interface ErrorDisplayProps {
  error: string;
  onRetry?: () => void;
  retrying?: boolean;
}

export function ErrorDisplay({ error, onRetry, retrying }: ErrorDisplayProps) {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      aria-live="polite"
      className="rounded-lg border border-error bg-error-soft px-6 py-5 text-center"
    >
      <AlertTriangle className="size-6 text-error mx-auto mb-2" aria-hidden />
      <p className="text-[14px] text-error font-heading font-semibold mb-3">{error}</p>
      {onRetry && (
        <Button
          variant="secondary"
          size="sm"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? (
            <>
              <Loader2 className="size-3.5 animate-spin mr-1.5" />
              {t('common.loading')}
            </>
          ) : (
            t('errorDisplay.retry')
          )}
        </Button>
      )}
    </div>
  );
}
